import React, { useState } from 'react'
import { Grid, Box, Flex } from '@chatterbug/aaron'

import SyncToCalendar from 'src/pages/SchedulePage/subcomponents/SyncToCalendar/SyncToCalendar'
import { t } from 'src/lib/i18n-react'
import routes from 'src/lib/rails-routes/rails-routes'
import Empty from 'src/ui/EmptyBox'
import Action from 'src/ui/Action/Action'

import AppointmentsListSkeleton from './AppointmentsListSkeleton'
import AppointmentListItem from './AppointmentListItem/AppointmentListItem'

const AppointmentsList = ({
  appointments,
  potentialAppointments = [],
  bookableAppointments = [],
  onCancel,
  onBookAsTrainer,
  onUpdateAppointment,
  onUpdatePotentialAppointment,
  iCalUrl,
}) => {
  const [isModalShown, setIsModalShown] = useState(false)
  const allAppointments = [...appointments, ...bookableAppointments]

  if (allAppointments?.length > 0 || potentialAppointments?.length > 0) {
    return (
      <AppointmentsListSkeleton
        listSection={
          <Grid as="section" gridGap="3x">
            <Grid
              bg="white100"
              borderRadius="1x"
              boxShadow="raised"
              gridGap="3x"
              py="3x"
              alignItems="start"
              px={{ _: '2x', tablet: '3x' }}
            >
              {potentialAppointments?.length > 0 && (
                <Box>
                  <Box as="p" variant="text.h5" mb="1x">
                    {`${t('Based on your Availability, we suggest')}:`}
                  </Box>
                  <Grid as="ul" gridGap="3x" px={0} pb="2x">
                    {potentialAppointments.map((potentialAppointment) => {
                      return (
                        <AppointmentListItem
                          key={potentialAppointment.id}
                          appointment={potentialAppointment}
                          onCancel={onCancel}
                          onBookAsTrainer={onBookAsTrainer}
                          onUpdateAppointment={onUpdateAppointment}
                          onUpdatePotentialAppointment={(action) =>
                            onUpdatePotentialAppointment(
                              potentialAppointment.id,
                              action
                            )
                          }
                        />
                      )
                    })}
                  </Grid>
                </Box>
              )}
              {allAppointments?.length > 0 && (
                <Grid as="ul" gridGap="3x" px={0}>
                  {allAppointments.map((appointment) => {
                    return (
                      <AppointmentListItem
                        key={appointment.id}
                        appointment={appointment}
                        onCancel={onCancel}
                        onBookAsTrainer={onBookAsTrainer}
                        onUpdateAppointment={onUpdateAppointment}
                      />
                    )
                  })}
                </Grid>
              )}
              <Flex
                justifyContent="space-between"
                alignItems="center"
                flexWrap="wrap"
                borderTopColor="gray80"
                borderTopWidth={1}
                borderTopStyle="solid"
                pt="1x"
              >
                <Action href={routes.schedule_availability()}>
                  {t('Set my Availability')}
                </Action>
                <Action onClick={() => setIsModalShown(true)}>
                  {t('Sync to Calendar')}
                </Action>
              </Flex>

              <SyncToCalendar
                iCalUrl={iCalUrl}
                isOpen={isModalShown}
                onClose={() => setIsModalShown(false)}
              />
            </Grid>
          </Grid>
        }
      />
    )
  }

  return (
    <Empty>
      <Box as="p" variant="text.paragraph" color="gray60">
        {t("You don't have any lesson scheduled yet.")}
      </Box>
    </Empty>
  )
}

export default AppointmentsList
